// This file is automatically generated. Do not edit manually.

import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace VertexToCustomerOfferLineApi {
	export async function importVertexFileToCustomerOfferLines(args: {
		customerOfferId: number;
		fileHandle: FrontendUploadFileHandle;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOffer/import/vertex/importVertexFileToCustomerOfferLines",
			method: "POST",
			data: {
				customerOfferId: args.customerOfferId,
				fileHandle: args.fileHandle,
			},
		});
		return response as void;
	}
}
